// extracted by mini-css-extract-plugin
export default {"page":"layoutIndex_page__tsp36","pageBody":"layoutIndex_pageBody__THuVn","mainCont":"layoutIndex_mainCont__zLvE-"};